import type { VendorStats } from '@/lib/vendorApi';

interface Props { stats: VendorStats }

export function StatsStrip({ stats }: Props) {
  return (
    <div className="grid grid-cols-4 gap-4 mb-6">
      {[
        { label: 'Total',         value: stats.total,         color: 'text-slate-100' },
        { label: 'Active',        value: stats.active,        color: 'text-emerald-400' },
        { label: 'Expiring Soon', value: stats.expiring_soon, color: 'text-amber-400' },
        { label: 'Expired',       value: stats.expired,       color: 'text-red-400' },
      ].map(({ label, value, color }) => (
        <div key={label} className="bg-slate-800 rounded-xl border border-slate-700 p-4 text-center">
          <div className={`text-3xl font-bold ${color}`}>{value}</div>
          <div className="text-xs text-slate-500 font-medium uppercase tracking-wide mt-1">{label}</div>
        </div>
      ))}
    </div>
  );
}
